import api from "./../api/axios";
import endpoints from "./../api/endpoints";

export const getRandQuestion = async (id) => {
    const url = endpoints.onboarding.question.get.random.replace('{userProfileId}', id);
    return await api.get(url);
};
export const setNextStep = async(stepPayload) => {
    const nextStepSet = await api.post(endpoints.onboarding.completeStep, stepPayload);
    return nextStepSet;
};